<template>
  <div>
    <h3 style="text-align: center;"><b>DANH SÁCH NHÂN VIÊN TỔNG HỢP</b></h3>

    <b-table
      id="my-table"
      bordered
      head-variant="dark"
      hover
      striped
      responsive
      small
      :fields="fields"
      :items="items"
      table-variant="light"
    >
      <template #cell(STT)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(ngaysinh)="data">{{
        formatDate(data.value)
      }}</template>
      <template v-slot:cell(ngaythuviec)="data">{{
        formatDate(data.value)
      }}</template>
      <template v-slot:cell(ngaychinhthuc)="data">{{
        formatDate(data.value)
      }}</template>
      <template v-slot:cell(tinhtranghoso)="data">
        <b-badge variant="success" v-if="data.value == 'On working'">
          {{ findEStatus(data.value) }}</b-badge
        >
        <b-badge variant="primary" v-else-if="data.value == 'Probation'">{{
          findEStatus(data.value)
        }}</b-badge>
        <b-badge variant="warning" v-else-if="data.value == 'Intern'">{{
          findEStatus(data.value)
        }}</b-badge>
        <b-badge variant="secondary" v-else-if="data.value == 'Collaborator'">{{
          findEStatus(data.value)
        }}</b-badge>
        <b-badge variant="danger" v-else-if="data.value == 'Leave'">{{
          findEStatus(data.value)
        }}</b-badge>
        <b-badge variant="info" v-else>{{ data.value }}</b-badge>
      </template>
    </b-table>
    <b-badge variant="light">Tổng số: {{ totalRow }}</b-badge>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Report1",
  //props: ["vitricongviecs", "loaihopdongs", "departments"],
  data() {
    return {
      fields: [
        {
          key: "STT",
          label: "STT",
          thClass: "align-middle",
          thStyle: { width: "15px", textAlign: "center" },
        },
        {
          key: "manhanvien",
          label: "Mã NV",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "80px", textAlign: "center" },
          tdClass: "text-center",
        },
        {
          key: "hovaten",
          label: "Họ và tên",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        // @Edit Thanh
        // {
        //   key: "gioitinh",
        //   label: "Giới tính",
        //   sortable: true,
        //   thClass: "text-center",
        // },
        // {
        //   key: "ngaysinh",
        //   label: "Ngày sinh",
        //   sortable: true,
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        {
          key: "vitricongviec",
          label: "Vị trí công việc",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "donvicongtacshort",
          label: "Đơn vị công tác",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "100px", textAlign: "center" },
          tdClass: "align-middle",
        },
        // {
        //   key: "ngaythuviec",
        //   label: "Ngày thử việc",
        //   sortable: true,
        // },
        // {
        //   key: "ngaychinhthuc",
        //   label: "Ngày chính thức",
        //   sortable: true,
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        // {
        //   key: "loaihopdong",
        //   label: "Loại hợp đồng",
        //   sortable: true,
        //   thClass: "text-center",
        // },
        {
          key: "email",
          label: "Email",
          sortable: true,
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "tinhtranghoso",
          label: "Tình trạng",
          sortable: true,
          thClass: "align-middle",
          thStyle: { width: "105px", textAlign: "center" },
        },
      ],
      items: [],
      totalRow: null,
    };
  },
  //  computed: {
  //   itemsWithSno() {
  //     return this.desserts.map((d, index) => ({ ...d, sno: index + 1 }))
  //   }
  // },
  // beforeRouteEnter(to, from, next) {
  //   let query = Object.assign({}, this.$route.query);
  //     query.report = 1;
  //     axios
  //       .get("/api/employeereport/get", { params: query })
  //       // .get(`/api/employee`, { params: query })
  //       .then((response) => {
  //         this.items = response.data.items;
  //       })
  //       .catch((err) => {});
  // },
  //   beforeRouteUpdate(to, from, next) {

  //   },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      let query = Object.assign({}, this.$route.query);
      query.report = 7;
      axios
        .get(`/api/employeereport/get`, { params: query })
        .then((response) => {
          this.items = response.data.items;
          this.totalRow = response.data.totalRow;
        })
        .catch((err) => {});
    },
    findFirst(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      return temp == null ? "" : temp.pickListValue;
    },
    findFirstDepartment(list, id) {
      const temp = list.find(function(el) {
        if (el.id == id) return el;
      });
      // @Edit thanh
      return temp == null ? "" : temp.madonvi;
    },
    findEStatus(status) {
      switch (status) {
        case "On working":
          status = "Working";
          break;
        case "Leave":
          status = "Quit job";
          break;
        case "Probation":
          status = "Probation";
          break;
        case "Intern":
          status = "Intern";
          break;
        case "Collaborator":
          status = "Collaborator";
          break;
      }
      return status;
    },
    formatDate(value) {
      if (!value) return "";
      return this.$moment(value).format("DD/MM/YYYY");
    },
    paginationChanged(ctx) {
      let query = Object.assign({}, this.$route.query);
      query.page = ctx;
      this.$router.push({ query: query });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
